import React, { useCallback, useEffect, useRef, useState } from "react";
import BootLoader from "./BootLoader";
import ContactTransmission from "./ContactTransmission";
import CredentialBadges from "./CredentialBadges";
import CRTOverlay from "./CRTOverlay";
import ExperienceTimeline from "./ExperienceTimeline";
import FeaturedSoftwareProjects from "./FeaturedSoftwareProjects";
import FluidBackground from "./FluidBackground";
import Footer from "./Footer";
import HeroCommandCenter from "./HeroCommandCenter";
import MissionProjects from "./MissionProjects";
import Navbar from "./Navbar";
import OperatorProfile from "./OperatorProfile";
import ResumeModule from "./ResumeModule";
import SecretTerminal from "./SecretTerminal";
import SkillModules from "./SkillModules";

function CyberPortfolio() {
  const [booting, setBooting] = useState(() => window.sessionStorage.getItem("eopsBooted") !== "true");
  const [secretOpen, setSecretOpen] = useState(false);
  const bufferRef = useRef("");
  const cursorRef = useRef(null);

  const endBoot = useCallback(() => {
    window.sessionStorage.setItem("eopsBooted", "true");
    setBooting(false);
  }, []);

  useEffect(() => {
    const move = (event) => {
      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
      }
    };

    const keydown = (event) => {
      const tag = event.target.tagName;
      const typing = tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
      if (!typing && event.key.length === 1) {
        bufferRef.current = `${bufferRef.current}${event.key.toLowerCase()}`.slice(-16);
        if (bufferRef.current.includes("sudo access")) {
          setSecretOpen(true);
          bufferRef.current = "";
        }
      }

      if (typing) return;
      const shortcuts = { h: "home", p: "projects", c: "contact" };
      const target = shortcuts[event.key.toLowerCase()];
      if (target) {
        document.getElementById(target)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    window.addEventListener("pointermove", move, { passive: true });
    window.addEventListener("keydown", keydown);

    return () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("keydown", keydown);
    };
  }, []);

  return (
    <div className="cyber-app">
      {booting && <BootLoader onComplete={endBoot} />}
      <FluidBackground />
      <CRTOverlay />
      <div className="cursor-glow" ref={cursorRef} aria-hidden="true" />
      <Navbar />
      <main>
        <HeroCommandCenter />
        <OperatorProfile />
        <SkillModules />
        <MissionProjects />
        <FeaturedSoftwareProjects />
        <ExperienceTimeline />
        <CredentialBadges />
        <ResumeModule />
        <ContactTransmission />
      </main>
      <SecretTerminal open={secretOpen} onClose={() => setSecretOpen(false)} />
      <Footer />
    </div>
  );
}

export default CyberPortfolio;
